import logoMark from '../../assets/samastix-only-logo.png';
import logoMarkFilled from '../../assets/samastix-logo-x-filled-removebg.png';

/**
 * Samastix icon mark (same assets as samastix.com marketing site).
 */
export default function SamastixLogoMark({ variant = 'default', className = '' }) {
  if (variant === 'dark') {
    return (
      <img
        src={logoMarkFilled}
        alt=""
        className={`block object-contain ${className}`}
        aria-hidden="true"
      />
    );
  }

  return (
    <img src={logoMark} alt="" className={className} aria-hidden="true" />
  );
}
